module.exports = __webpack_public_path__ + "img/help.b7fa8ccc.png";